import React, { useEffect } from "react";
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Drawer from '@material-ui/core/Drawer';
import Box from '@material-ui/core/Box';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import Badge from '@material-ui/core/Badge';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Link from '@material-ui/core/Link';
import { Link as RouterLink } from 'react-router-dom';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import NotificationsIcon from '@material-ui/icons/Notifications';
import { MainListItems } from './listItems';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUpRightFromSquare } from '@fortawesome/pro-solid-svg-icons';


import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

import { useAuth } from "../Auth/auth";
import ImpersonationBanner from "./ImpersonationBanner";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: 'none',
  },
  title: {
    flexGrow: 1,
  },
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9),
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
    paddingLeft: "0", paddingRight: "0"
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: 240,
  },
}));

const Page = (props) => {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [renderHeader, setRenderHeader] = React.useState(false);

  const { user, postLogout } = useAuth();
  const [dropdownOpen, setDropdownOpen] = React.useState(false);

  const toggle = () => setDropdownOpen(prevState => !prevState);

  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const handleDrawerClose = () => {
    setOpen(false);
  };

  const logout = () => {
    postLogout();
  }

  const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);

  useEffect(() => {
    document.title = props.title || "";
  }, [props.title]);

  useEffect(() => {
    if(user != null){
      setRenderHeader(true)
    }else{
      setRenderHeader(false)
    }
  }, [user]);

  return(
    <div className={classes.root}>
      <CssBaseline />
      <AppBar position="absolute" className={clsx(classes.appBar, open && classes.appBarShift)} style={{backgroundColor: "black", zIndex: 20}}>
        <Toolbar className={classes.toolbar}>
          {renderHeader &&
            <IconButton
              edge="start"
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              className={clsx(classes.menuButton, open && classes.menuButtonHidden)}
            >
              <MenuIcon />
            </IconButton>
          }

          <Typography component="h1" variant="h4" color="inherit" noWrap className="header-title px-4 py-2 mb-0" style={{flexGrow: 1}}>
            <a href="/" style={{color: "white"}}>Tayda Manufacturing Center</a>
              <span className="tagline ml-4">
                <a href="https://www.taydaelectronics.com/hardware/enclosures.html" target="_blank" rel="noopener noreferrer" title="Tayda Electronics" >Store <span style={{fontSize: '0.4em', paddingBottom: '0.2em'}}>
                <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
              </span>
            </a>
            </span>
          </Typography>
          { user == null && (
            <Link className="mr-3 nav-links" href="/design-experiment" style={{color: "white"}}>Experiment with Drill Tool</Link>
          )}
          {renderHeader &&
            <Dropdown className="btn btn-secondary p-0" isOpen={dropdownOpen} toggle={toggle}>
                <DropdownToggle caret >
                    <span style={{fontSize: '0.8em'}}>
                        {user != null ? user["email"] : ""}
                    </span>
                </DropdownToggle>
                <DropdownMenu>
                    <DropdownItem tag={RouterLink} to="/change-password">Change Password</DropdownItem>
                    <DropdownItem divider />
                    <DropdownItem onClick={logout}>Logout</DropdownItem>
                </DropdownMenu>
            </Dropdown>
          }
          {/*
          <IconButton color="inherit">
            <Badge badgeContent={4} color="secondary">
              <NotificationsIcon />
            </Badge>
          </IconButton>
          */}
        </Toolbar>
      </AppBar>
      {renderHeader &&
        <Drawer className="custom-side-bar"
          variant="permanent"
          classes={{
            paper: clsx(classes.drawerPaper, !open && classes.drawerPaperClose),
          }}
          open={open}
        >
          <div className={classes.toolbarIcon}>
            <IconButton onClick={handleDrawerClose}>
              <ChevronLeftIcon />
            </IconButton>
          </div>
          <Divider />
          <List><MainListItems /></List>
        </Drawer>
      }
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <ImpersonationBanner />
        <Container maxWidth="lg" className={classes.container}>
          {props.children}
        </Container>
      </main>
    </div>
  )
};

/*
{props.children}
*/

export default Page;